package br.com.vvrefeicoes.portal.core.di

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import br.com.vvrefeicoes.portal.domain.model.PermissionAction

@Composable
fun rememberSessionPermissions(): Map<String, Set<PermissionAction>> {
    val appGraph = LocalAppGraph.current
    val session by appGraph.authRepository.session.collectAsStateWithLifecycle()
    return session?.permissions.orEmpty()
}
